import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgScoreWordmark = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "score-wordmark_svg__Layer_1",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	viewBox: "0 0 1770.2 469.09",
	...props,
	children: [/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("style", { children: ".score-wordmark_svg__cls-1{fill:url(#score-wordmark_svg__linear-gradient)}" }), /* @__PURE__ */ _jsxs("linearGradient", {
		id: "score-wordmark_svg__linear-gradient",
		x1: 348.31,
		y1: -259.06,
		x2: 1126.06,
		y2: 666.57,
		gradientUnits: "userSpaceOnUse",
		children: [
			/* @__PURE__ */ _jsx("stop", {
				offset: .05,
				stopColor: "#cd7099"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .07,
				stopColor: "#c56d98"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .24,
				stopColor: "#7b5697"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .36,
				stopColor: "#4c4796"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .43,
				stopColor: "#3b4296"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .5,
				stopColor: "#3a4a99"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .62,
				stopColor: "#3a61a1"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .77,
				stopColor: "#3a86af"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .79,
				stopColor: "#3a8bb1"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .93,
				stopColor: "#62c7ba"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#78e8c0"
			})
		]
	})] }), /* @__PURE__ */ _jsx("path", {
		className: "score-wordmark_svg__cls-1",
		d: "M163.22,469.09c-65.91,0-118.65-20.2-163.22-56.68l43.94-71.01c32.64,25.41,74.08,48.21,122.41,48.21s74.7-18.89,74.7-53.42c0-84.7-222.23-22.15-222.23-198.06C18.83,51.47,87.26,0,176.4,0,229.76,0,276.21,12.38,325.18,54.08l-43.94,69.06c-31.39-26.06-65.91-43.65-103.58-43.65-40.81,0-67.17,20.2-67.17,51.47,0,89.91,221.6,24.76,221.6,196.76,0,81.44-59.64,141.38-168.87,141.38ZM651.81,191.55l-51.48,53.42c-19.46-22.15-38.92-33.88-72.82-33.88-46.45,0-79.1,30.62-79.1,91.86s32.64,91.86,79.1,91.86c33.9,0,53.36-12.38,72.82-33.88l51.48,53.42c-35.78,40.39-81.61,54.73-124.3,54.73-94.79,0-163.22-63.2-163.22-166.14s68.42-166.14,163.22-166.14c42.69,0,88.51,14.33,124.3,54.73ZM819.24,136.82c92.91,0,158.82,65.8,158.82,166.14s-65.92,166.14-158.82,166.14-159.45-65.8-159.45-166.14,66.54-166.14,159.45-166.14ZM819.24,394.82c48.97,0,75.33-35.83,75.33-91.86s-26.37-91.86-75.33-91.86-75.33,35.83-75.33,91.86,26.37,91.86,75.33,91.86ZM1095.74,347.26v115.32h-81.61V143.33h81.61v65.8c21.35-52.77,62.15-72.32,109.23-72.32v89.91c-86.63,0-109.23,41.04-109.23,120.53ZM1517.83,322.5h-209.67c5.65,50.82,35.15,77.53,79.1,77.53,35.16,0,57.75-11.73,77.84-31.27l46.45,48.21c-42.69,41.7-91.03,52.12-131.83,52.12-94.79,0-156.31-63.85-156.31-166.14s70.31-166.14,155.05-166.14c89.77,0,139.36,57.33,139.36,151.15v34.53ZM1433.71,265.17c0-35.18-18.83-63.2-57.75-63.2-35.16,0-57.75,22.8-65.92,63.2h123.67ZM1595.12,381.55c0-54.71,39.6-87.54,87.54-87.54s87.54,32.83,87.54,87.54-39.6,87.54-87.54,87.54-87.54-32.83-87.54-87.54Z"
	})]
});
export default SvgScoreWordmark;
